import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IoMdClose } from "react-icons/io";
import "./answerAndReplyNotificationModal.css";
import answerIcon from "src/Assets/images/answerIcon.png";
import replyIcon from "src/Assets/images/message new icon.png";
import askIcon from "src/Assets/images/ask.svg";
import sayIcon from "src/Assets/images/say.svg";
import updateIcon from "src/Assets/images/update.svg";
import tagIcon from "src/Assets/images/tag.svg";
import AnswerAndReplyModalPost from "./AnswerAndReplyModalPost";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 600,
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "#E5E4E2",
  border: "none",
  borderRadius: 5,
  px: 4, // padding left + right
  py: 2, // padding top + bottom
};

export default function AnswerAndReplyNotificationModal(props) {
  const {
    openAnswerAndReplyModal,
    ansOrReplyLoading,
    answerAndReplyMessageData,
    onCloseAnswerAndReplyModal,
    ansAndReplyKeword,
    onDelete,
    likeUnlike,
    updateMessage,
    updateNewSelectedLocation,
    removeNewSelectedLocationKey,
    tagName,
    flaggedReason,
    onReject,
    approveAction,
    notificationId,
    senderId
  } = props;

  const getHeaderInfo = () => {
    const firstPost = answerAndReplyMessageData?.[0];
    const msgType = firstPost?.message_type;
    const keywordId = firstPost?.Keyword_ID;

    if (msgType === "A" || keywordId === "OpenASK") {
      return { icon: askIcon, title: "ASK" };
    } else if (msgType === "S" || keywordId === "OpenSAY") {
      return { icon: sayIcon, title: "SAY" };
    } else if (
      msgType === "I" ||
      keywordId === "impupdate" ||
      keywordId === "UPDATE"
    ) {
      return { icon: updateIcon, title: "UPDATE" };
    } else if (
      msgType === "H" ||
      msgType === "X" ||
      keywordId === "hashTAG"
    ) {
      return { icon: tagIcon, title: "TAG" };
    } else if (ansAndReplyKeword === "W") {
      return { icon: answerIcon, title: "Answer" };
    } else if (ansAndReplyKeword === "P") {
      return { icon: replyIcon, title: "Reply" };
    }
    return { icon: askIcon, title: "ASK" };
  };

  const headerInfo = getHeaderInfo();

  return (
    <div>
      <Modal
        open={openAnswerAndReplyModal}
        onClose={onCloseAnswerAndReplyModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="ans-and-reply--modal-header">
            <div
              className="ans-and-reply-icon-container"
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              <img
                src={headerInfo.icon}
                alt={headerInfo.title}
                className="answer-icon"
                style={{ width: 26, height: 26, objectFit: "contain" }}
              />
              <Typography className="ask" style={{ fontWeight: 400, fontSize: 16, color: "#373334" }}>
                {headerInfo.title}
              </Typography>
            </div>
            <button
              type="button"
              onClick={() => {
                onCloseAnswerAndReplyModal();
              }}
            >
              <IoMdClose className="block-modal-close-icon" />
            </button>
          </div>
          <AnswerAndReplyModalPost
            ansOrReplyLoading={ansOrReplyLoading}
            answerAndReplyMessageData={answerAndReplyMessageData}
            onDelete={onDelete}
            likeUnlike={likeUnlike}
            updateMessage={updateMessage}
            updateNewSelectedLocation={updateNewSelectedLocation}
            removeNewSelectedLocationKey={removeNewSelectedLocationKey}
            tagName={tagName}
            postType={ansAndReplyKeword === "W" ? "Answer" : "Reply"}
            flaggedReason={flaggedReason}
            ansAndReplyKeword={ansAndReplyKeword}
            onReject={onReject}
            approveAction={approveAction}
            notificationId={notificationId}
            senderId={senderId}
            onCloseAnswerAndReplyModal={onCloseAnswerAndReplyModal}
            filterType={
              ansAndReplyKeword === "W"
                ? "AnswerNotification"
                : ansAndReplyKeword === "P"
                ? "ReplyNotification"
                : "FlaggedNotification"
            }
          />
        </Box>
      </Modal>
    </div>
  );
}
